export const gender = {
    en: [
        {
            label: "Female", //"Female",
            value: 0,
        },
        {
            label: "Male", //"Male",
            value: 1,
        },
    ],
    zh_tc: [
        {
            label: "女",
            value: 0,
        },
        {
            label: "男",
            value: 1,
        },
    ],
};

export const level = [
    {
        label: "*",
        value: 1,
    },
    {
        label: "**",
        value: 2,
    },
    {
        label: "***",
        value: 3,
    },
    {
        label: "****",
        value: 4,
    },
    {
        label: "*****",
        value: 5,
    },
];
export const roleName = {
    student: "student",
    parent: "parent",
};
export const language = {
    en: "en",
    zh_tc: "zh_tc",
};
export const grade = [
    {
        label: "P1",
        value: 1,
    },
    {
        label: "P2",
        value: 2,
    },
    {
        label: "P3",
        value: 3,
    },
    {
        label: "P4",
        value: 4,
    },
    {
        label: "P5",
        value: 5,
    },
    {
        label: "P6",
        value: 6,
    },
];

export const scope = {
    // en: ["Numbers & Operations", "Shapes & Measurement", "Applications & Thinking"],
    // zh_tc: ["數與運算", "圖形與測量", "應用與思維"],
    en: ["I.Numbers & Operations", "II.Shapes & Measurement", "III.Applications & Thinking"], //['Part A','Part B','Part C'],//['Number','Measurement and Graph and Space','Number and Data Processing'],
    zh_tc: ["I.數與運算", "II.圖形與測量", "III.應用與思維"], //['數','量度及圖形與空間','數及數據處理'],
};

export const paymentType = {
    en: ["網上付款", "管理員開通", "分校付款", "升級", "其他"], //["Online Payment","Administrator Activation","Branch Payment","Upgradation","Other"],
    zh_tc: ["網上付款", "管理員開通", "分校付款", "升級", "其他"],
};

export const address = [
    {
        value: "Hong Kong China 中國香港 +852",
        label: "Hong Kong China 中國香港 +852",
        children: [
            {
                value: "香港島 Hong Kong Island",
                label: "香港島 Hong Kong Island",
                children: [
                    {
                        value: "中西區 Central and Western",
                        label: "中西區 Central and Western",
                    },
                    {
                        value: "香港東區 Eastern",
                        label: "香港東區 Eastern",
                    },
                    {
                        value: "香港南區 Southern",
                        label: "香港南區 Southern",
                    },
                    {
                        value: "灣仔區 Wan Chai",
                        label: "灣仔區 Wan Chai",
                    },
                ],
            },
            {
                value: "九龍 Kowloon",
                label: "九龍 Kowloon",
                children: [
                    {
                        value: "九龍城區 Kowloon City",
                        label: "九龍城區 Kowloon City",
                    },
                    {
                        value: "觀塘區 Kwun Tong",
                        label: "觀塘區 Kwun Tong",
                    },
                    {
                        value: "深水埗區 Sham Shui Po",
                        label: "深水埗區 Sham Shui Po",
                    },
                    {
                        value: "黃大仙區 Wong Tai Sin",
                        label: "黃大仙區 Wong Tai Sin",
                    },
                    {
                        value: "油尖旺區 Yau Tsim Mong",
                        label: "油尖旺區 Yau Tsim Mong",
                    },
                ],
            },
            {
                value: "新界 New Territories",
                label: "新界 New Territories",
                children: [
                    {
                        value: "離島區 Islands",
                        label: "離島區 Islands",
                    },
                    {
                        value: "葵青區 Kwai Tsing",
                        label: "葵青區 Kwai Tsing",
                    },
                    {
                        value: "北區 North",
                        label: "北區 North",
                    },
                    {
                        value: "西貢區 Sai Kung",
                        label: "西貢區 Sai Kung",
                    },
                    {
                        value: "沙田區 Sha Tin",
                        label: "沙田區 Sha Tin",
                    },
                    {
                        value: "大埔區 Tai Po",
                        label: "大埔區 Tai Po",
                    },
                    {
                        value: "荃灣區 Tsuen Wan",
                        label: "荃灣區 Tsuen Wan",
                    },
                    {
                        value: "屯門區 Tuen Mun",
                        label: "屯門區 Tuen Mun",
                    },
                    {
                        value: "元朗區 Yuen Long",
                        label: "元朗區 Yuen Long",
                    },
                ],
            },
        ],
    },
    {
        value: "Macau China 中國澳門 +853",
        label: "Macau China 中國澳門 +853",
        children: [
            {
                value: "澳門 Macau",
                label: "澳門 Macau",
            },
        ],
    },
    {
        value: "Mainland China 中國大陸 +86",
        label: "Mainland China 中國大陸 +86",
        children: [
            {
                value: "廣州 Guangzhou",
                label: "廣州 Guangzhou",
            },
            {
                value: "中國內地 China",
                label: "中國內地 China",
            },
        ],
    },
    {
        value: "Singapore 新加坡 +65",
        label: "Singapore 新加坡 +65",
        children: [
            {
                value: "新加坡 Singapore",
                label: "新加坡 Singapore",
            },
        ],
    },
    {
        value: "Canada 加拿大 +1",
        label: "Canada 加拿大 +1",
        children: [
            {
                value: "列治文 Richmond",
                label: "列治文 Richmond",
            },
            {
                value: "溫哥華西區 Kerrisdale",
                label: "溫哥華西區 Kerrisdale",
            },
        ],
    },
    {
        value: "Others 其他",
        label: "Others 其他",
    },
];
export const areaCode = [
    {
        label: "+852",
        value: "852",
    },
    {
        label: "+853",
        value: "853",
    },
    {
        label: "+86",
        value: "86",
    },
    {
        label: "+65",
        value: "65",
    },
    {
        label: "+1",
        value: "1",
    },
];
export const directory = {
    en: {
        title: "Your child will learn",
        topic: [
            {
                label: "First Grade",
                value: [
                    "Numbers within 20",
                    "Basic Addition and Subtraction",
                    "Solid Graph (1)",
                    "Direction and Position (1)",
                    "Length and Distance (1)",
                    "Numbers within 100",
                    "Addition and Subtraction (1)",
                    "Flat Figure",
                    "Currency (1)",
                    "Length and Distance (2)",
                    "Time (1)",
                ],
            },
            {
                label: "Second Grade",
                value: [
                    "Three Digit",
                    "Addition and Subtraction (2)",
                    "Basic Multiplication",
                    "Solid Graph (2)",
                    "Angle",
                    "Length and Distance (3)",
                    "Time (2)",
                    "Four Digit",
                    "Addition and Subtraction (3)",
                    "Basic Division",
                    "Direction and Position (2)",
                    "Quadrilateral (1)",
                    "Currency (2)",
                    "Pictogram",
                ],
            },
            {
                label: "Third Grade",
                value: [
                    "Five Digit",
                    "Multiplication (1)",
                    "Division (1)",
                    "Quadrilateral (2)",
                    "Length and Distance (4)",
                    "Time (3)",
                    "Four Operations (1)",
                    "Fraction (1)",
                    "Weight",
                    "Triangle",
                    "Capacity",
                    "Time (4)",
                    "Bar Graph (1)",
                ],
            },
            {
                label: "Fourth Grade",
                value: [
                    "Multiplication (2)",
                    "Division (2)",
                    "Multiples and Factors",
                    "Common multiples and Common factors",
                    "Quadrilateral (3)",
                    "Perimeter (1)",
                    "Direction and Position (3)",
                    "Four Operations (2)",
                    "Fraction (2)",
                    "Decimal (1)",
                    "Graph tiling and segmentation",
                    "Area (1)",
                    "Bar Graph (2)",
                ],
            },
            {
                label: "Fifth Grade",
                value: [
                    "Multiple Digits",
                    "Fraction (3)",
                    "Fraction (4)",
                    "Area (2)",
                    "Pictogram",
                    "Preliminary Understanding of Algebra",
                    "Bar Graph (3)",
                    "Circle",
                    "Decimal (3)",
                    "Fraction (5)",
                    "Solid Graph (3)",
                    "Volume (1)",
                    "Simple Equation (1)",
                ],
            },
            {
                label: "Sixth Grade",
                value: [
                    "Decimal (4)",
                    "Decimal (5)",
                    "Percentage (1)",
                    "Perimeter (2)",
                    "Area (3)",
                    "Volume (2)",
                    "Average",
                    "Percentage (2)",
                    "Symmetry",
                    "Angle (degree)",
                    "Rate",
                    "Line Chart",
                    "Simple Equation",
                    "Circular Chart",
                    "Statistical application and misuse",
                ],
            },
        ],
    },
    zh_tc: {
        title: "你的小朋友將會學到什麼？",
        topic: [
            {
                label: "小一",
                value: [
                    "20以內的數",
                    "基本加法和減法",
                    "立體圖形（一）",
                    "方向和位置（一）",
                    "長度和距離（一）",
                    "100以內的數",
                    "加法和減法（一）",
                    "平面圖形",
                    "貨幣（一）",
                    "長度和距離（二）",
                    "時間（一）",
                ],
            },
            {
                label: "小二",
                value: [
                    "三位數",
                    "加法和減法（二）",
                    "基本乘法",
                    "立體圖形（二）",
                    "角",
                    "長度和距離（三）",
                    "時間（二）",
                    "四位數",
                    "加法和減法（三）",
                    "基本除法",
                    "方向和位置（二）",
                    "四邊形（一）",
                    "貨幣（二）",
                    "象形圖",
                ],
            },
            {
                label: "小三",
                value: [
                    "五位數",
                    "乘法（一）",
                    "除法（一）",
                    "四邊形（二）",
                    "長度和距離（四）",
                    "時間（三）",
                    "四則運算（一）",
                    "分數（一）",
                    "重量",
                    "三角形",
                    "容量",
                    "時間（四）",
                    "棒形圖（一）",
                ],
            },
            {
                label: "小四",
                value: [
                    "乘法（二）",
                    "除法（二）",
                    "倍數和因數",
                    "公倍數和公因數",
                    "四邊形（三）",
                    "周界（一）",
                    "方向和位置（三）",
                    "四則計算（二）",
                    "分數（二）",
                    "小數（一）",
                    "圖形拼砌與分割",
                    "面積（一）",
                    "棒形圖（二）",
                ],
            },
            {
                label: "小五",
                value: [
                    "多位數",
                    "分數（三）",
                    "分數（四）",
                    "面積（二）",
                    "象形圖",
                    "代數的初步認識",
                    "棒形圖(三)",
                    "圓",
                    "小數（三）",
                    "分數（五）",
                    "立體圖形（三）",
                    "體積（一）",
                    "簡易方程（一）",
                ],
            },
            {
                label: "小六",
                value: [
                    "小數（四）",
                    "小數（五）",
                    "百分數（一）",
                    "周界（二）",
                    "面積（三）",
                    "體積（二）",
                    "平均數",
                    "百分數（二）",
                    "對稱",
                    "角（度）",
                    "速率",
                    "折線圖",
                    "簡易方程",
                    "圓形圖",
                    "統計的應用及誤用",
                ],
            },
        ],
    },
};
